// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserLastLoginCell} from './UserLastLoginCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserActionsCell} from './UserActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import moment from 'moment'
import {Badge} from 'react-bootstrap'
import {numberFormat} from '../../../../../../utils/Functions'
import StateLabel from '../../../../../../components/grid/StateLabel'
import StateActionGroup from '../../../StateActionGroup'
import {Link} from 'react-router-dom'

const usersColumns: any = (onUpdate) => ([
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: 'selection',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index].id} />,
  // },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='เลขที่เอกสาร' className='min-w-125px' />,
    id: 'id',
    accessor: 'code',
    Cell: (r) => {
      const origin = r.row.original
      return <Link to={`/expense-purchase-order/${origin.id}/detail`}>{r.value || '-'}</Link>
    },
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='ชื่อผู้ขาย' className='min-w-150px' />,
    id: 'fullName',
    accessor: 'labCompany',
    Cell: (r) => <span>{r.value?.name || '-'}</span>,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='วันที่ออก' className='min-w-125px' />,
    id: 'date',
    accessor: 'date',
    Cell: (r) => <span>{moment(r.value).format('DD/MM/YYYY')}</span>,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='มูลค่าสุทธิ' className='min-w-125px' />,
    id: 'netAmount',
    accessor: 'netAmount',
    Cell: (r) => <span>{numberFormat(r.value || 0)}</span>,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='มูลค่าที่ออกแล้ว' className='min-w-125px' />,
    id: 'issuedAmount',
    accessor: 'issuedAmount',
    Cell: (r) => {
      const origin = r.row.original
      return (
        <span>
          {numberFormat(
            (typeof origin?.remainTotalAmount === 'number' && typeof origin?.totalAmount === 'number')
              ? origin.totalAmount - origin.remainTotalAmount
              : 0
          )}
        </span>
      )
    },
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='สถานะ' className='min-w-125px' />,
    id: 'state',
    accessor: 'state',
    Cell: (r) => (
      <div className={'l-grid-action-wrapper'}>
        <StateActionGroup data={r.row.original} />
      </div>
    ),
  },
])

export {usersColumns}
